























import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import _ from 'lodash'
import OpenCardsList from '@/components/OpenCardsList.vue'
import OpenCardsStats from '@/components/OpenCardsStats.vue'
import CardDetailsModal from '@/components/CardModals/CardDetailsModal.vue'
import CardLabelsFilter from '@/components/CardFilters/CardLabelsFilter.vue'
import { TrelloCard } from '@/TrelloClient'
import { uiConfig } from '@/config'

@Component({
    components: {
        OpenCardsList,
        OpenCardsStats,
        CardDetailsModal,
        CardLabelsFilter,
    },
})
export default class extends Vue {

    get openCards(): TrelloCard[] {
        return this.$store.state.openCards
    }

    get activeMemberId(): string {
        return this.$store.state.activeMemberId
    }

    get filteredCards(): TrelloCard[] {
        return this.$store.getters.filteredOpenCards
    }

    fetching: Boolean = true

    @Watch('activeMemberId')
    fetchOpenCards(newMemberId: string, oldMemberId: string) {
        this.fetching = true
        this.$store.dispatch('fetchOpenCards', { memberId: newMemberId }).then(() => {
            this.fetching = false
        })
    }

    get showOpenCardsStats() {
        return uiConfig.showOpenCardsStats
    }

}
